import axios from 'axios'
import { host } from '../../helper/config'
import { ITEM_PER_PAGE } from '../../helper/helper'

const PLUGINS_NAME = 'admin-cashback-history'

const headers = (token) => ({
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Authorization': token
})

export const getListCashbackHistory = async (token, query, page) => {
    const response = await axios.post(
        `${host}/${PLUGINS_NAME}/get-list`,
        {
            ...query,
            page: page,
            itemPerPage: ITEM_PER_PAGE
        },
        {
            headers: headers(token),
        }
    )

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const getSummaryCashbackHistory = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-summary`, {
        ...query
    }, {
        headers: headers(token),
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getCsvCashbackHistory = async (token, query, page, totalPage) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-csv`, {
        ...query,
        page: page,
        itemPerPage: ITEM_PER_PAGE,
        totalPage: totalPage
    }, {
        headers: headers(token),
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}
